import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { BusinessRulesListComponent } from './business-rules-list/business-rules-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { MatAutocompleteModule, MatExpansionModule } from '@angular/material';
import { BusinessRulesMinPriceGrowthComponent } from './business-rules-components/business-rules-minPriceGrowth/business-rules-minPriceGrowth.component';
import { BusinessRulesMinSoloGrowthComponent } from './business-rules-components/business-rules-minSoloGrowth/business-rules-minSoloGrowth.component';
import { BusinessRulesMaxPriceDropComponent } from './business-rules-components/business-rules-maxPriceDrop/business-rules-maxPriceDrop.component';
import { RemoveRuleDialogComponent } from './remove-rule-dialog/remove-rule-dialog.component';
import { BusinessRulesBlockTypeComponent } from './business-rules-components/business-rules-blockType/business-rules-blockType.component';
import { BusinessRulesLengthRuleTypeComponent } from './business-rules-components/business-rules-lengthRuleType/business-rules-lengthRuleType.component';
import { BusinessRulesBlockOfferComponent } from './business-rules-components/business-rules-blockOffer/business-rules-blockOffer';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    MaterialModule,
    RouterModule,
    FormsModule,
    MatExpansionModule,
    MatAutocompleteModule,
    TranslateModule
  ],
  declarations: [
    BusinessRulesListComponent,
    BusinessRulesLengthRuleTypeComponent,
    BusinessRulesMaxPriceDropComponent,
    BusinessRulesMinPriceGrowthComponent,
    BusinessRulesBlockTypeComponent,
    BusinessRulesMinSoloGrowthComponent,
    BusinessRulesBlockOfferComponent,
    RemoveRuleDialogComponent
  ],
  entryComponents: [RemoveRuleDialogComponent]
})
export class BusinessRulesModule {}



// WEBPACK FOOTER //
// ./src/app/modules/business-rules/business-rules.module.ts